module.exports = __webpack_public_path__ + "img/1548173274.284515cf.jpg";